import { useRef, useState } from 'react';
import { useDebounceCallback } from '../useDebounceCallback';
export function useDebounceValue(initialValue, delay, options) {
    var _a;
    const eq = (_a = options === null || options === void 0 ? void 0 : options.equalityFn) !== null && _a !== void 0 ? _a : ((left, right) => left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = useState(unwrappedInitialValue);
    const previousValueRef = useRef(unwrappedInitialValue);
    const updateDebouncedValue = useDebounceCallback(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [debouncedValue, updateDebouncedValue];
}
